export const DataSourcesFileFormatList = [
  { value: 'csv', label: 'CSV' },
  { value: 'json', label: 'JSON' },
  { value: 'parquet', label: 'PARQUET' },
];
